import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"

import { snapboxLogout } from "services"
import { Button, ConfirmationModal } from "components"
import classes from "./TnSnappboxLogoutButton.module.scss"

const TnSnappboxLogoutButton = (props) => {
  const {
    selectedBranch,
    setSelectedBranch,
    setNeedOtp
  } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const handleLogout = async () => {
    setSending(true)

    try {
      await snapboxLogout(selectedBranch._id)

      setNeedOtp(true)

      setOpenConfirmationModal(false)

      setSelectedBranch(null)
    } catch (err) {
      console.log(err)

      toast.error(t("خروج_انجام_نشد"))

      setSending(false)
    }
  }

  return (
    <Fragment>
      <Button
        tooltip={t("خروج_از_snappbox")}
        className={classes["button"]}
        onClick={() => setOpenConfirmationModal(true)}
      >
        {t("خروج")}
      </Button>

      <ConfirmationModal
        show={openConfirmationModal}
        title={t("آیا_می_خواهید_از_snappbox_خارج_شوید")}
        onHide={() => setOpenConfirmationModal(false)}
        onConfirm={handleLogout}
        onExited={() => setSending(false)}
        sending={sending}
      />
    </Fragment>
  )
}

export default TnSnappboxLogoutButton
